module.exports = __webpack_public_path__ + "media/images/flags/64/Seychelles-fd9e0ebe084c775dfbe668c30e70d641.png";